import { render, staticRenderFns } from "./AdicionarPessoas.vue?vue&type=template&id=fe90319e&scoped=true"
import script from "./AdicionarPessoas.vue?vue&type=script&lang=js"
export * from "./AdicionarPessoas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe90319e",
  null
  
)

export default component.exports